var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"holder",staticClass:"synchronized-parallax parallax-wrapper",class:[_vm.className, { 
        'wrapped': _vm.wrapped, 
        'not-wrapped': !_vm.wrapped, 
        'position-absolute': _vm.absolute,
        'active-on-mobile': _vm.activeOnMobile
    }]},[_c('div',{ref:"parallax",staticClass:"parallax",style:(_vm.elStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }